import { SUBMOTIVE2_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useSubmotive2List } from './hook';
import { Submotive2ListProps } from './props';

export const Submotive2List = ({ filters }: Submotive2ListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useSubmotive2List(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${SUBMOTIVE2_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
